<template>
  <div class="navbar-container d-flex m-0 justify-content-between p-0">
    <div
      class="d-flex content align-items-center m-0 "
      style="width: 50%"
    >
      <FilesBackButton
        :disabled="!hasBack"
        @click="goBack"
      />

      <FilesBreadcrumb
        :breadcrumb="breadcrumb"
        :class-item="classItem"
        :current-folder="currentFolder"
        @go-to="goTo"
      />
    </div>

    <div class="d-flex content align-items-center m-0 ">
      <MultipleFileContextMenu
        :selected-files="selectedFiles"
        :files-number="filesNumber"
        @select-all="selectAll"
      />
    </div>

    <div
      class="flex-wrap"
    >
      <ViewModeToggle />

      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="my-button d-sm-none d-md-inline ml-2"
        style="border: none"
        variant="outline-primary"
        @click="reload()"
      >
        <font-awesome-icon
          icon="arrows-rotate"
          size="lg"
        />
      </b-button>
      <FilesAddButton
        v-if="canAdd"
        @add-folder="addFolder"
      />
      <b-button
        v-else
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="m-md-2"
        variant="primary"
        @click="openDownloadsModal()"
      >
        <font-awesome-icon
          icon="file-zipper"
          size="lg"
          class="mr-50"
        />
        I miei download
      </b-button>
    </div>
  </div>
</template>

<script>
import useMyStore from '@/services/useMyStore'
import bulkDownload from '@/helpers/bulk-download'
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import MultipleFileContextMenu from '@/layouts/components/MultipleFileContextMenu'
import FilesBreadcrumb from '@/layouts/components/FilesBreadcrumb'
import ViewModeToggle from './ViewModeToggle.vue'
import FilesBackButton from './FilesBackButton.vue'
import FilesAddButton from './FilesAddButton.vue'

export default {
  name: 'FilesNavbar',
  directives: {
    Ripple,
  },
  components: {
    FilesBreadcrumb,
    MultipleFileContextMenu,
    FilesAddButton,
    ViewModeToggle,
    FilesBackButton,
    BButton,
  },
  props: {
    selectedFiles: {
      type: Array,
      default: () => {},
    },
    breadcrumb: {
      type: Array,
      default: () => [],
    },
    filesNumber: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      canAdd: true,
    }
  },
  computed: {
    hasBack() {
      return this.currentFolder !== 0
    },
    classItem() {
      if (this.breadcrumb.length > 6) {
        return 'ml-1'
      }
      return ''
    },
    // selectedFilesCount() {
    //   this.selectedFiles = this.selectedFiles.length
    // }
  },
  mounted() {
    this.canAdd = this.$can('upload', 'object')
  },
  setup() {
    const { currentFolder } = useMyStore()

    return {
      currentFolder,
    }
  },
  methods: {
    goBack() {
      // const test = fetch(`/api/files/${this.currentFolder}`)
      // test.then(response => response.json())
      //   .then(data => {
      //     this.currentFolder = data.father_id
      //   })
      // todo get current folder -1
      if (this.currentFolder !== 'null' && this.currentFolder !== null) {
        this.$emit('go-back')
      }
    },
    goTo(id) {
      this.currentFolder = id
    },
    addFolder() {
      this.$emit('add-folder')
    },
    reload() {
      this.$emit('reload')
    },
    openDownloadsModal() {
      this.$bvModal.show(bulkDownload.DOWNLOADS_MODAL_ID)
    },
    selectAll(val1) {
      this.$emit('select-all', val1)
    },
  },
}
</script>
